import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProject, BackendQueryProjectForNewCopiesArgs } from 'src/types/backend';

const QUERY = gql`
  query ProjectForNewCopies($workspaceId: ID!) {
    projectForNewCopies(workspaceId: $workspaceId) {
      id
    }
  }
`;

type Variables = BackendQueryProjectForNewCopiesArgs;
type Result = Pick<BackendProject, 'id'>;

export const queryProjectForNewCopies = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
